export const SET_FORM_MODAL_OPEN = "SET_FORM_MODAL_OPEN";
export const SET_FORM_MODAL_ERROR = "SET_FORM_MODAL_ERROR";